import _ from 'lodash'
export function compareObjects(o1: any, o2: any) {
    return _.isEqual(o1, o2)
}
